<template>
  <v-app class="app">
    <v-app-bar app clipped-left color="primary accent-4" dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="pl-2">
        <v-img
          :alt="$vuetify.lang.t('$vuetify.appName')"
          :src="'/img/logo.png'"
          width="120"
        >
        </v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn depressed outlined> {{ $auth.user().balance }} XAF </v-btn>
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list class="menu-app-bar">
          <v-list-item @click="logout()">
            <v-list-item-title>{{
              $vuetify.lang.t("$vuetify.menu.logout")
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer app clipped v-model="drawer">
      <v-list>
        <v-list-item>
          <v-list-item-avatar size="50">
            <v-img src="/img/user.png"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold body-1">{{
              $auth.user().profile.fullName
            }}</v-list-item-title>
            <v-list-item-subtitle>{{
              $vuetify.lang.t("$vuetify.roles." + $auth.user().role)
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list dense nav>
        <v-list-item
          :to="{ name: 'dashboard' }"
          exact
          exact-active-class="secondary lighten-5"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold subtitle-1"
              >{{ $vuetify.lang.t("$vuetify.menu.dashboard") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'application' }"
          active-class="secondary lighten-5"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-apps</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold subtitle-1"
              >{{ $vuetify.lang.t("$vuetify.menu.application") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'payment' }"
          active-class="secondary lighten-5"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-cards-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold subtitle-1"
              >{{ $vuetify.lang.t("$vuetify.menu.payment") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'transfer' }"
          active-class="secondary lighten-5"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-bank-transfer</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold subtitle-1"
              >{{ $vuetify.lang.t("$vuetify.menu.transfer") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'provision' }"
          exact
          exact-active-class="secondary lighten-5"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-cash</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold subtitle-1"
              >{{ $vuetify.lang.t("$vuetify.menu.provision") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!--        <v-list-item :to="{ name: 'jobs' }" exact exact-active-class="secondary lighten-5"-->
        <!--                     link v-if="$auth.check(['ROLE_ADMIN'])">-->
        <!--          <v-list-item-icon>-->
        <!--            <v-icon>mdi-calendar-clock</v-icon>-->
        <!--          </v-list-item-icon>-->
        <!--          <v-list-item-content>-->
        <!--            <v-list-item-title-->
        <!--              class="font-weight-bold subtitle-1"-->
        <!--            >{{ $vuetify.lang.t('$vuetify.menu.jobs') }}-->
        <!--            </v-list-item-title>-->
        <!--          </v-list-item-content>-->
        <!--        </v-list-item>-->
        <v-list-item
          :to="{ name: 'users' }"
          exact
          exact-active-class="secondary lighten-5"
          link
          v-if="$auth.check(['ROLE_ADMIN', 'ROLE_COMPTA'])"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-multiple-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold subtitle-1"
              >{{ $vuetify.lang.t("$vuetify.menu.user") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'profile' }"
          exact
          exact-active-class="secondary lighten-5"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-account-settings-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold subtitle-1"
              >{{ $vuetify.lang.t("$vuetify.menu.profile") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          exact
          exact-active-class="secondary lighten-5"
          href="/docs/"
          link
          target="_blank"
        >
          <v-list-item-icon>
            <v-icon>mdi-link-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold subtitle-1"
              >{{ $vuetify.lang.t("$vuetify.menu.docs") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <v-container class="pt-5 px-5" fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import URLPath from "../helpers/URL";

export default {
  data: () => ({
    drawer: true
  }),
  methods: {
    logout: function() {
      const tokenName = process.env.VUE_APP_TOKEN_NAME;
      let self = this;
      let params = {
        url: URLPath.SECURITY.LOGOUT.URI,
        method: URLPath.SECURITY.LOGOUT.METHOD,
        data: {
          refresh_token: JSON.parse(this.$auth.token(tokenName)).refresh_token
        }
      };
      this.$store
        .dispatch("request", params)
        .then(() => {
          self.$auth.token(null);
          self.$router.push({ name: "login" });
        })
        .catch(() => {
          self.$store.dispatch("setNotification", {
            status: true,
            message: this.$vuetify.lang.t("$vuetify.error_occured")
          });
        });
    }
  }
};
</script>
